import { render, staticRenderFns } from "./AuthorizeCarsBatch.vue?vue&type=template&id=0528a000&scoped=true&"
import script from "./AuthorizeCarsBatch.vue?vue&type=script&lang=js&"
export * from "./AuthorizeCarsBatch.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizeCarsBatch.vue?vue&type=style&index=0&id=0528a000&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0528a000",
  null
  
)

export default component.exports